import React, { useState } from "react";
import { Heart } from "lucide-react";
import { FaMinus, FaPlus } from "react-icons/fa";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import { addToCart, addToWishlist, removeFromCart, removeFromWishlist } from "../../../store/slice/userActions";
import { getFileUrl } from "../../../utils/helper";
import { IoIosInformationCircleOutline } from "react-icons/io";
import useModal from "../../../hooks/ui/useModal";
import Modal from "../../ui/utils/Modal";

const ProductCardSmall = ({ product }) => {
  const dispatch = useDispatch();

  const [quantity, setQuantity] = useState(product?.cart_quantity || 0);
  const [isAdding, setIsAdding] = useState(false);
  const [isWishlisted, setIsWishlisted] = useState(product?.is_favourite || false);

  const { isOpen, openModal, closeModal, actionType } = useModal();

  const updateCart = async (type, e) => {
    e.stopPropagation();
    if (isAdding) return;

    try {
      setIsAdding(true);

      if (type === "D" && quantity === 1) {
        await dispatch(removeFromCart(product?._id)).unwrap();
        setQuantity(0);
        return;
      }

      await dispatch(
        addToCart({
          productId: product?._id,
          quantity: 1,
          type, // "I" | "D"
        })
      ).unwrap();

      setQuantity((prev) => (type === "I" ? prev + 1 : prev - 1));
    } catch {
      toast.error("Cart update failed");
    } finally {
      setIsAdding(false);
    }
  };

  const handleWishlist = async (e) => {
    e.stopPropagation();

    try {
      if (isWishlisted) {
        await dispatch(removeFromWishlist(product?._id)).unwrap();
        setIsWishlisted(false);
        toast.success("Removed from wishlist");
      } else {
        await dispatch(
          addToWishlist({ productId: product?._id })
        ).unwrap();
        setIsWishlisted(true);
        toast.success("Added to wishlist");
      }
    } catch {
      toast.error("Wishlist update failed");
    }
  };


  const imgSrc = getFileUrl(product?.image);

  return (
    <div className="bg-white rounded-2xl border hover:shadow-lg transition p-3">
      <div className="relative">
        <img
          src={imgSrc}
          alt={product?.name}
          className={`w-full h-32 object-contain transition ${!product?.is_available ? "blur-sm opacity-70" : ""
            }`}
        />

        {!product?.is_available && (
          <div className="absolute inset-0 bg-black/40 flex items-center justify-center rounded-lg">
            <span className="bg-red-500 text-white text-xs font-bold px-4 py-1.5 rounded-full shadow">
              Not Available
            </span>
          </div>
        )}

        {product?.vendorPrice > product?.finalPrice && (
          <span className="absolute top-2 left-2 bg-blue-600 text-white text-xs font-bold px-2 py-1 rounded">
            {Math.round(
              ((product.vendorPrice - product.finalPrice) /
                product.vendorPrice) *
              100
            )}
            % OFF
          </span>
        )}

        <button
          onClick={handleWishlist}
          className="absolute top-2 right-2 bg-white p-2 rounded-full shadow"
        >
          <Heart
            size={16}
            className={
              isWishlisted
                ? "fill-red-500 text-red-500"
                : "text-gray-500"
            }
          />
        </button>
      </div>


      <div className="mt-3">
        <div className="flex justify-between items-center gap-1">
          <h3 className="text-sm font-semibold line-clamp-2">
            {product?.name}
          </h3>
          {
            product.description != "" ?
              <button
                onClick={() =>
                  openModal({ type: "viewDescription", data: { state: product } })
                }
                className={`text-blue-600 bg-slate-100 p-2 rounded-full hover:bg-slate-600`}
                title="View"
              >
                <IoIosInformationCircleOutline size={18} />

              </button>
              : ''
          }

        </div>


        <div className="flex justify-between items-center mt-3">
          <div>
            <div className="text-lg font-bold">
              ₹{product?.finalPrice}
            </div>
            {product?.vendorPrice > product?.finalPrice && (
              <div className="text-xs text-gray-400 line-through">
                ₹{product?.vendorPrice}
              </div>
            )}
          </div>

          {!product?.is_available ? (
            <span className="text-red-500 font-semibold text-sm">
              Not Available
            </span>
          ) : quantity === 0 ? (
            <div className="flex flex-col gap-2">
              <button
                onClick={(e) => updateCart("I", e)}
                className="border border-green-600 text-green-600 font-bold px-6 py-1.5 rounded-lg hover:bg-green-50 transition"
              >
                ADD
              </button>
            </div>
          ) : (
            <div className="flex items-center bg-green-600 rounded-lg overflow-hidden">
              <button
                onClick={(e) => updateCart("D", e)}
                className="px-3 py-2 text-white hover:bg-green-700"
              >
                <FaMinus size={12} />
              </button>

              <span className="px-4 text-white font-bold">
                {quantity}
              </span>

              <button
                onClick={(e) => updateCart("I", e)}
                className="px-3 py-2 text-white hover:bg-green-700"
              >
                <FaPlus size={12} />
              </button>
            </div>
          )}


          <Modal isOpen={isOpen} onClose={closeModal} size="large">


            {actionType?.type === "viewDescription" && (
              <div className="p-2 ">
                {actionType?.data?.state?.description}
              </div>
            )}

          </Modal>

        </div>
      </div>
    </div>
  );
};

export default ProductCardSmall;
